import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Message } from 'primeng/primeng';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TarifNameService } from '../tarif-name.service';
import { TarifName } from '../tarif-name';
import { NgForm } from '@angular/forms';



@Component({
  selector: 'app-tarif-name-crud',
  templateUrl: './tarif-name-crud.component.html',
  styleUrls: ['./tarif-name-crud.component.css'],
  providers: [TarifNameService]
})
export class TarifNameCrudComponent implements OnInit {
  
  id: any = null;
  tarifName: TarifName;
  msgs: Message[] = [];
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";
  
  constructor(
  			  private tarifNameService: TarifNameService,
              private activatedRoute: ActivatedRoute,
              private location: Location
  			  ) {

  	activatedRoute.params.subscribe(params=>{this.id=params['id']});


   		  if(this.id){
   		  	this.tarifNameService.getTarifNameById(this.id).subscribe(response=>{this.tarifName=response['data'];});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }

   }

  ngOnInit() {

  		this.tarifName={
  			  id: "",
			  name: "",
			  available: true
  	    };
  }

  backClicked() {
        this.location.back();
  }

    crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.tarifNameService.createTarifName(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});console.log(data);});

   		  }else{
   		  	this.tarifNameService.updateTarifName(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});console.log(data);});
   		  }



  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/tarifs/tarif-name-crud/tarif-name-crud.component.ts